import {
  LOAD_DAILYTEXTS,
  LOAD_DAILYTEXTS_SUCCESS,
  LOAD_DAILYTEXTS_ERROR
} from "../actions/dailytexts";

export default ({ user_id }) => (dispatch, getState) => {
  dispatch({ type: LOAD_DAILYTEXTS });
  return fetch(
    `${process.env.REACT_APP_DTDATA_URI}/dts/findHoursAndDays/${user_id}`
  )
    .then(res => res.json())
    .then(payload => {
      if (!payload) throw new Error("No dts found");
      return payload;
    })
    .then(payload => dispatch({ type: LOAD_DAILYTEXTS_SUCCESS, payload }))
    .catch(({ message: payload }) =>
      dispatch({ type: LOAD_DAILYTEXTS_ERROR, payload })
    );
};



// WEBPACK FOOTER //
// ./src/store/epics/loadDailyTextData.js